import React from 'react';
import ThemeToggle from '../../General/ThemeToggle';

const Header = () => {
  return (
    <div className='flex items-center justify-between w-full h-14 sm:h-16 lg:h-18 bg-white dark:bg-gray-800 text-gray-900 dark:text-white px-4 sm:px-6 lg:px-8 shadow-vox border-b border-gray-200 dark:border-gray-700 relative z-40 transition-colors duration-300'>
      <h2 className='text-lg sm:text-xl lg:text-2xl font-bold text-vox-blue-900 dark:text-white hover:text-vox-green-500 transition-colors duration-200 cursor-pointer truncate'>
        <span className="hidden sm:inline">Bem vindo ao </span>Vox ERP
      </h2>
      
      <div className='flex items-center gap-2 sm:gap-4'>
        {/* <nav className='hidden md:flex items-center gap-3 lg:gap-6'>
          <a href="#" className='text-gray-600 dark:text-white font-medium px-2 lg:px-3 py-2 rounded-lg transition-all duration-200 bg-vox-blue-100 dark:bg-vox-green-600 text-vox-blue-900 dark:text-white text-sm lg:text-base'>
            Dashboard
          </a>
          <a href="#" className='text-gray-600 dark:text-white font-medium px-2 lg:px-3 py-2 rounded-lg transition-all duration-200 hover:text-vox-blue-900 dark:hover:text-vox-green-400 hover:bg-gray-50 dark:hover:bg-gray-700 text-sm lg:text-base'>
            Relatórios
          </a>
          <a href="#" className='text-gray-600 dark:text-white font-medium px-2 lg:px-3 py-2 rounded-lg transition-all duration-200 hover:text-vox-blue-900 dark:hover:text-vox-green-400 hover:bg-gray-50 dark:hover:bg-gray-700 text-sm lg:text-base'>
            Configurações
          </a>
        </nav> */}
        
        {/* Menu dropdown para mobile */}
        <div className="md:hidden relative">
          <button className="p-2 text-gray-600 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        
        <div data-tour-id="tema">
          <ThemeToggle />
        </div>
      </div>
    </div>
  );
};

export default Header;
